import messages from './footer-translations';

export default {
    name: 'instamapsFooter',
    i18n: {
        messages,
    },
    data () {
        return {
            theme: 'base',
        };
    },
    props: {
        isViewerMode: { type: Boolean },
    },
    components: {
    },
};



// WEBPACK FOOTER //
// ./src/shared/components/footer/footer.js